import React from 'react';
import { AvatarGroup, Box, Typography } from '@mui/material';
import { Participant } from '../types/generated/graphql';
import GravatarAvatar from './GravatarAvatar';
import { colors } from '../theme/colors';

interface ParticipantAvatarsProps {
  participants: Participant[];
  maxAvatars?: number;
  size?: number;
  showLabel?: boolean;
}

/**
 * Display a group of participant avatars using Gravatar with initials fallback
 */
export const ParticipantAvatars: React.FC<ParticipantAvatarsProps> = ({
  participants,
  maxAvatars = 5,
  size = 32,
  showLabel = false,
}) => {
  if (!participants || participants.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <AvatarGroup
        max={maxAvatars}
        sx={{
          '& .MuiAvatar-root': {
            width: size,
            height: size,
            fontSize: size * 0.38,
            fontWeight: 600,
            border: `2px solid ${colors.card}`,
          },
          '& .MuiAvatarGroup-avatar': {
            bgcolor: colors.gray[400],
            color: 'white',
            width: size,
            height: size,
            fontSize: size * 0.35,
          },
        }}
      >
        {participants.map((participant) => (
          <GravatarAvatar
            key={participant.id}
            email={participant.email}
            name={participant.name}
            size={size}
            showTooltip={true}
          />
        ))}
      </AvatarGroup>
      {showLabel && participants.length > 0 && (
        <Typography
          variant="caption"
          sx={{ color: colors.textSecondary, fontWeight: 500 }}
        >
          {participants.length} {participants.length === 1 ? 'participant' : 'participants'}
        </Typography>
      )}
    </Box>
  );
};

export default ParticipantAvatars;
